import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["submitButton", "option"]

  connect() {
    this.toggleSubmitButton()
  }

  toggleSubmitButton() {
    const anyChecked = this.optionTargets.some(option => option.checked)

    if (anyChecked) {
      this.submitButtonTarget.disabled = false
      this.submitButtonTarget.classList.remove("disabled")
    } else {
      this.submitButtonTarget.disabled = true
      this.submitButtonTarget.classList.add("disabled")
    }
  }
}
